import styled from '@emotion/styled';

import { spacing, borderRadius, colors, shadows, transitions, typography } from '../tokens';

/**
 * Valores estimados do print — revalidar com Figma quando a cota resetar.
 */
const spec = {
  border: colors.border,    // #E8E8E8
  titleColor: '#3D3D3D',
  chevronColor: '#8C8C8C',  // TEXTOS_ABASTECIMENTO.md — Chevron: cor #8C8C8C
};

export const SectionRoot = styled('div')`
  box-sizing: border-box;
  width: 100%;
  background-color: ${colors.background};
  border-radius: ${borderRadius.lg};
  box-shadow: ${shadows.sm};
  border: 1px solid ${spec.border};
  overflow: hidden;
`;

export const SectionHeader = styled('button')<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.lg};
  width: 100%;
  padding: ${spacing.lg};
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: 2px solid #000FFF;
    outline-offset: -2px;
    border-radius: ${borderRadius.lg};
  }
`;

export const SectionTitle = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: 22px;            /* TEXTOS_ABASTECIMENTO.md — "Nível do gás": 22px bold */
  line-height: 28px;
  font-weight: ${typography.fontWeight.extraBold};
  color: ${spec.titleColor};  /* #3D3D3D */
  flex: 1;
  min-width: 0;
  text-align: left;
`;

export const SectionHeaderRight = styled('span')`
  display: flex;
  align-items: center;
  gap: ${spacing.md};
  flex-shrink: 0;
`;

export const ChevronIcon = styled('span', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $expanded: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${spec.chevronColor};
  transition: transform ${transitions.base};
  transform: ${({ $expanded }) => ($expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;

/**
 * Clip externo: só controla max-height + overflow. Sem padding — senão o
 * conteúdo bate na parede no frame em que padding vai a 0 antes de max-height
 * fechar.
 */
export const SectionBody = styled('div', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $expanded: boolean }>`
  overflow: hidden;
  max-height: ${({ $expanded }) => ($expanded ? '2000px' : '0')};
  transition: max-height 0.3s ease;
`;

/**
 * Wrapper interno com padding fixo. Como não anima, o conteúdo mantém o
 * espaçamento durante toda a animação de colapso.
 */
export const SectionBodyInner = styled('div')`
  padding: 0 ${spacing.lg} ${spacing.lg};
`;
